import { useEffect } from 'react';
import ReactDOM from 'react-dom';

const ModalPortal = (props) => {
    const modal = __isBrowser__ && document.createElement('div');

    useEffect(() => {
        if (__isBrowser__) {
            const modalRoot = document.getElementById('modal-root');
            modalRoot.appendChild(modal);
        }
        return () => {
            if (__isBrowser__) {
                const modalRoot = document.getElementById('modal-root');
                modalRoot.removeChild(modal);
            }
        };
    }, []);

    return ReactDOM.createPortal(props.children, modal);
};
export default ModalPortal;
